import { IUseGetUsersOwnTractorsParams } from '../../../hooks/api/user/queries/useGetUsersOwnTractors';
import { IBrand } from '../../../interfaces/Brand.interfaces';
import { IMachineListMachine } from '../../../interfaces/Dictionary.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export type IMachineForUserOwnTractor = Pick<
  IMachineListMachine,
  'id' | 'model' | 'approvalStatus' | 'engineOutputInPs'
>;

export interface IUserOwnTractor {
  id: string;
  brand: Omit<IBrand, 'country'>;
  machine: IMachineForUserOwnTractor;
  engineOutputInPs: number;
  manufacturedYear: number;
  operationTime: number;
  marketPrice: number | null;
}

type IGetUsersOwnTractorsParams = Pick<IUseGetUsersOwnTractorsParams, 'searchParam'>;

export const getUsersOwnTractors = ({ searchParam }: IGetUsersOwnTractorsParams): Promise<IUserOwnTractor[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/user-own-tractors?${URLSearchParams}`);
};
